import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import Contact from "@/components/sections/Contact";

export default function ContactPage() {
    return (
        <PageShell>
            <div data-testid="contact-page">
                <PageHeader
                    eyebrow="Contact"
                    title="Send a message or"
                    accent="book a call."
                    subtitle="Reach us by email, phone, or directly book a 20-minute discovery slot with our outreach team. Replies within one business day."
                    breadcrumbs={[{ label: "Contact" }]}
                />
                <Contact />
            </div>
        </PageShell>
    );
}
